import React, { Component } from 'react';
import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import RestServices from '../services/RestServices.js';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from 'react-bootstrap/Alert';
import { withAuthorization } from '../Session';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import { fontSize } from '@mui/system';

class ManageCommission extends Component {
    _isMounted = false;
    _isMounted = false;

    state = {
        alert: 0,
        alertMessage: '',
        flag: 0,
        showLoading:true,
		daily_credit_limit:0,
        credit : 0,
		netbanking:0,
		wallet:0,
		emi:0,
		upi:0,
        paylater:0,
        credit_status:false,
        netbanking_status:false,
        upi_status:false,
        virtual_status:false,
        debit_status:false,
        wallet_status:false,
        emi_status:false,
        paylater_status:false,
        virtual:0,
        debit:0,
        PaymentGatewayList:[],
        selectedItem: [],
        title:'',
        manageCommission:false
    };
    constructor(props) {
        super(props);
    }

    async componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadPaymentGateway();
        
    }


    async loadPaymentGateway() {
        await RestServices.GlobalGet(
            localStorage.getItem('FirebaseToken'),
            'configuration/GetAllPaymentGateway'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    
                    this.setState({ 
                    showLoading: false,
                    PaymentGatewayList : responseData.data
                    });
                
                
                   
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ showLoading: false,alert: 1, alertMessage: err.message });
                }
            });
    }

    

 
 
    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };
    handleStatusChange = (item) => {
        if(item == 'credit_status' ){
            this.setState({ credit_status: !this.state.credit_status });
        }
        if(item == 'netbanking_status' ){
            this.setState({ netbanking_status: !this.state.netbanking_status });
        }
        if(item == 'upi_status' ){
            this.setState({ upi_status: !this.state.upi_status });
        }
        if(item == 'virtual_status' ){
            this.setState({ virtual_status: !this.state.virtual_status });
        }
        if(item == 'debit_status' ){
            this.setState({ debit_status: !this.state.debit_status });
        }
        if(item == 'wallet_status' ){
            this.setState({ wallet_status: !this.state.wallet_status });
        }
        if(item == 'emi_status' ){
            this.setState({ emi_status: !this.state.emi_status });
        }
        
        if(item == 'paylater_status' ){
            this.setState({ paylater_status: !this.state.paylater_status });
        }
        
    }
    handleIBDefaultCheckboxChange= (item) => {
        if(item.ibdefault ==0){
        item.ibdefault=1
        this.setState({
            selectedItem:item, 
            confirmStatusUpdate:true,
            confirmDefaultUpdate:true,
            updateibdefault:true,
            updateinstadefault:false
        });
    }
        
    };
    handleDefaultCheckboxChange = (item) => {
        console.log(item)
        if(item.instadefault ==0){
        item.instadefault=1
        this.setState({
            selectedItem:item, 
            confirmStatusUpdate:true,
            confirmDefaultUpdate:true,
            updateibdefault:false,
            updateinstadefault:true
        });
       }
    };

    handleCheckboxChange = (item) => {
        item.status=item.status !== 'disabled'?'disabled':'active'
        this.setState({
            selectedItem:item, 
            confirmStatusUpdate:true,
            confirmDefaultUpdate:false,
            updateibdefault:false,
            updateinstadefault:false
        });
        
    };
    handleCloseConfirm= () => {
        if (this._isMounted) {
            this.setState({selectedItem:[],confirmStatusUpdate: false,confirmDefaultUpdate:false});
        }
    }
    updateGatewayStatusOnly= () => {
        this.setState({showLoading: true });
        let bodyData = {
            docID: this.state.selectedItem.docID?this.state.selectedItem.docID:'',
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        
        if(this.state.confirmStatusUpdate){
            bodyData['status'] = this.state.selectedItem.status?this.state.selectedItem.status:'disabled'
        }
        if(this.state.updateibdefault){
            bodyData['ibdefault'] = this.state.selectedItem.ibdefault?this.state.selectedItem.ibdefault:0
        }
        if(this.state.updateinstadefault){
            bodyData['instadefault'] = this.state.selectedItem.instadefault?this.state.selectedItem.instadefault:0
        }
        this.setState({ confirmStatusUpdate: false,confirmDefaultUpdate:false });
        
        RestServices.GlobalPost(
        localStorage.getItem('FirebaseToken'),
        bodyData,
        'configuration/AddNewPaymentGateway'
        )
        .then((response) => response.json())
        .then((responseData) => {
            if (responseData.error) {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: responseData.error
                    });
                }
            } else {
                this.loadPaymentGateway();
                if (this._isMounted) {
                    this.setState({
                        alert: 2,
                        alertMessage: 'Payment gateway updated...'
                    });
                }
                
            }
        })
        .catch((err) => {
            if (this._isMounted) {
                this.setState({ showLoading: false,alert: 1, alertMessage: err.message });
            }
        });
    }
    updateGatewayStatus= () => {
    this.setState({showLoading: true });
    let bodyData = {
        title: this.state.selectedItem.title?this.state.selectedItem.title:this.state.title,
        docID: this.state.selectedItem.docID?this.state.selectedItem.docID:'',
        daily_credit_limit:this.state.daily_credit_limit,
        payment_option:{
        credit :{
            charge:this.state.credit,
            status: this.state.credit_status
        } ,
        netbanking:{
            charge:this.state.netbanking,
            status: this.state.netbanking_status
        },
        wallet:{
            charge:this.state.wallet,
            status: this.state.wallet_status
        },
        emi:{
            charge:this.state.emi,
            status: this.state.emi_status
        },
        upi:{
            charge:this.state.upi,
            status: this.state.upi_status
        },
        debit:{
            charge:this.state.debit,
            status: this.state.debit_status
        },
        paylater:{
            charge:this.state.paylater,
            status: this.state.paylater_status
        },
        virtual:{
            charge:this.state.virtual,
            status: this.state.virtual_status
        }

        },
        LastUpdatedTimeStamp: dateFormatUtil(),
        UpdatedBy: this.props.user.FullName
            ? this.props.user.FullName
            : 'Admin'
    };
    
    
    RestServices.GlobalPost(
    localStorage.getItem('FirebaseToken'),
    bodyData,
    'configuration/AddNewPaymentGateway'
    )
    .then((response) => response.json())
    .then((responseData) => {
        this.setState({ showLoading: false,confirmStatusUpdate: false,confirmDefaultUpdate:false });
        if (responseData.error) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: responseData.error
                });
            }
        } else {
            this.loadPaymentGateway();
            if (this._isMounted) {
                this.setState({
                    alert: 2,
                    alertMessage: 'Payment gateway updated...'
                });
            }
            
        }
    })
    .catch((err) => {
        if (this._isMounted) {
            this.setState({ showLoading: false,alert: 1, alertMessage: err.message });
        }
    });
    
    }

    AddNewGateway= () => {
        this.setState({showLoading: true });
        let postdata = {
            title: this.state.title,
            docID: '',
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            postdata,
            'configuration/AddNewPaymentGateway'
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({modalShow:false, showLoading: false, });
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    this.loadPaymentGateway();
                    if (this._isMounted) {
                        this.setState({selectedItem:[]});
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({modalShow:false,showLoading: false, alert: 1, alertMessage: err.message });
                }
            });

    }

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false });
        }
    };

    manageCommissionShow=(item)=>{
        console.log('item',item)
        try{
        if (this._isMounted) {

            this.setState({
                    daily_credit_limit:item.daily_credit_limit?item.daily_credit_limit:0,
                    selectedItem:item, 
                    manageCommission: true 
                });

                if(item.payment_option){
                    this.setState({
                    credit : item.payment_option.credit?item.payment_option.credit.charge:0,
				    netbanking:item.payment_option.netbanking?item.payment_option.netbanking.charge:0,
				    wallet:item.payment_option.wallet?item.payment_option.wallet.charge:0,
				    emi:item.payment_option.emi?item.payment_option.emi.charge:0,
				    upi:item.payment_option.upi?item.payment_option.upi.charge:0,
                    paylater:item.payment_option.paylater?item.payment_option.paylater.charge:0,
                    virtual:item.payment_option.virtual?item.payment_option.virtual.charge:0,
                    debit:item.payment_option.debit?item.payment_option.debit.charge:0,

                    credit_status:item.payment_option.credit?item.payment_option.credit.status:false,
                    netbanking_status:item.payment_option.netbanking?item.payment_option.netbanking.status:false,
                    upi_status:item.payment_option.upi?item.payment_option.upi.status:false,
                    virtual_status:item.payment_option.virtual?item.payment_option.virtual.status:false,
                    debit_status:item.payment_option.debit?item.payment_option.debit.status:false,
                    wallet_status:item.payment_option.wallet?item.payment_option.wallet.status:false,
                    emi_status:item.payment_option.emi?item.payment_option.emi.status:false,
                    paylater_status:item.payment_option.paylater?item.payment_option.paylater.status:false,

                });
                }
         }
        }catch(err){
            console.log(err.message)
        }
    }

    manageCommissionHide=()=>{
        if (this._isMounted) {
            this.setState({selectedItem:[], manageCommission: false });
        }
    }
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                
				<Row>
				<h4 style={{ marginLeft: '1rem',marginRight: '1rem'}} >
				Payment Gateway Configuration
				</h4>
				</Row>
				<div>
				<hr />
				</div>
                        
               {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}
                         
            {this.state.showLoading && <Spinner animation="border" />}

            
            <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Payment Gateway Accounts"
                            columns={[
                                {
                                    title: 'Name',
                                    field: 'title'
                                },
                                {
                                    title: 'Status',
                                    field: 'status',
                                    render: (row) => (
                                        <div>
                                    <Checkbox
                                        name={row.docID}
                                        checked={row.status !== 'disabled'}
                                        onChange={(e) =>
                                            this.handleCheckboxChange(row)
                                        }
                                    />
                                </div>
                                    )
                                    
                                },
                                {
                                    title: 'Insta Default',
                                    field: 'instadefault',
                                    render: (row) => (
                                        <div>
                                            <input
                                                type="radio"
                                                name='instadefault'
                                                checked={row.instadefault==1}
                                                onChange={(e) =>
                                                    this.handleDefaultCheckboxChange(row)
                                                }
                                            />

                                    
                                </div>
                                    )
                                    
                                },
                                {
                                    title: 'Indiabuy Default',
                                    field: 'ibdefault',
                                    render: (row) => (
                                        <div>
                                            <input
                                                type="radio"
                                                name='ibdefault'
                                                checked={row.ibdefault==1}
                                                onChange={(e) =>
                                                    this.handleIBDefaultCheckboxChange(row)
                                                }
                                            />
                                </div>
                                    )
                                    
                                },
                                {
                                    title: 'Commission',
                                    field: '',
                                    render: (row) => (
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue'
                                            }}
                                            onClick={(e) =>
                                                this.manageCommissionShow(row)
                                            }
                                        >
                                            Manage
                                        </div>
                                    )
                                },
                                
                            ]}
                            data={this.state.PaymentGatewayList}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                <div>
				<hr />
				</div>
            {this.state.manageCommission && <>
            <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem',
                                    fontSize:'16px'
                                }}
                            >
                                {this.state.selectedItem.title} Commission's (0 will be considered as off)
                            </h4>
            </Row> 
                <div>
				<hr />
				</div> 
                
                <Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Daily Credit Limit (in Rs)</Form.Label>
						<Form.Control
							placeholder="Enter Daily Limit"
							type="number"
							name="daily_credit_limit"
							value={this.state.daily_credit_limit}
							onChange={this.onChangeValues}
							required
						/>
					</Form.Group>
				</Form.Row>

				<Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Visa/Master Credit Card (in %)</Form.Label>
                        <Checkbox
                            name='credit_status'
                            checked={this.state.credit_status}
                            onChange={(e) =>
                                this.handleStatusChange('credit_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="credit"
							value={this.state.credit}
							onChange={this.onChangeValues}
							readOnly={!this.state.credit_status}
						/>
					</Form.Group>
				</Form.Row>
				
				<Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Netbanking (in %)</Form.Label>
						<Checkbox
                            name='netbanking_status'
                            checked={this.state.netbanking_status}
                            onChange={(e) =>
                                this.handleStatusChange('netbanking_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="netbanking"
							value={this.state.netbanking}
							onChange={this.onChangeValues}
							readOnly={!this.state.netbanking_status}
						/>
					</Form.Group>
				</Form.Row>
                <Form.Row>
					<Form.Group as={Col}>
						<Form.Label>UPI (in %)</Form.Label>
						<Checkbox
                            name='upi_status'
                            checked={this.state.upi_status}
                            onChange={(e) =>
                                this.handleStatusChange('upi_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="upi"
							value={this.state.upi}
							onChange={this.onChangeValues}
							readOnly={!this.state.upi_status}
						/>
					</Form.Group>
				</Form.Row>

                <Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Virtual Account (fixed)</Form.Label>
						<Checkbox
                            name='virtual_status'
                            checked={this.state.virtual_status}
                            onChange={(e) =>
                                this.handleStatusChange('virtual_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="virtual"
							value={this.state.virtual}
							onChange={this.onChangeValues}
							readOnly={!this.state.virtual_status}
						/>
					</Form.Group>
				</Form.Row>

                <Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Debit Card (in %)</Form.Label>
						<Checkbox
                            name='debit_status'
                            checked={this.state.debit_status}
                            onChange={(e) =>
                                this.handleStatusChange('debit_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="debit"
							value={this.state.debit}
							onChange={this.onChangeValues}
							readOnly={!this.state.debit_status}
						/>
					</Form.Group>
				</Form.Row>

				<Form.Row>
					<Form.Group as={Col}>
						<Form.Label>Wallet (in %)</Form.Label>
						<Checkbox
                            name='wallet_status'
                            checked={this.state.wallet_status}
                            onChange={(e) =>
                                this.handleStatusChange('wallet_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="wallet"
							value={this.state.wallet}
							onChange={this.onChangeValues}
							readOnly={!this.state.wallet_status}
						/>
					</Form.Group>
				</Form.Row>



				<Form.Row>
					<Form.Group as={Col}>
						<Form.Label>EMI (in %)</Form.Label>
						<Checkbox
                            name='emi_status'
                            checked={this.state.emi_status}
                            onChange={(e) =>
                                this.handleStatusChange('emi_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="emi"
							value={this.state.emi}
							onChange={this.onChangeValues}
							readOnly={!this.state.emi_status}
						/>
					</Form.Group>
				</Form.Row>


				

                <Form.Row>
					<Form.Group as={Col}>
						<Form.Label>PayLater (in %)</Form.Label>
						<Checkbox
                            name='paylater_status'
                            checked={this.state.paylater_status}
                            onChange={(e) =>
                                this.handleStatusChange('paylater_status')
                            }
                        />
						<Form.Control
							placeholder="Enter commission"
							type="number"
							name="paylater"
							value={this.state.paylater}
							onChange={this.onChangeValues}
							readOnly={!this.state.paylater_status}
						/>
					</Form.Group>
				</Form.Row>

                
				
				
				<hr />
                        <Form.Row>
                        <Button variant="secondary" onClick={this.manageCommissionHide}>
                            Cancel
                        </Button>
                           <Button style={{
                                    marginLeft: '1rem',
                                }} variant="primary" type="submit" onClick={this.updateGatewayStatus}  >
                                Update Commission
                            </Button>
                        </Form.Row>
            </>}


                        <Modal
                    show={this.state.confirmStatusUpdate}
                    onHide={this.handleCloseConfirm}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {!this.state.confirmDefaultUpdate ?<p>Are you sure you want to {this.state.selectedItem.status!='disabled'?'Activate':'Disabled'} this Payment Gateway?</p>:<p>Are you sure you want to make {this.state.selectedItem.title} Default Payment Gateway?</p>}

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseConfirm}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.updateGatewayStatusOnly} >
                            Yes
                        </Button>
                        
                    </Modal.Footer>
                </Modal>  
               


                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                    <Modal.Title>Add Payment Gateway</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                     <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    placeholder="Enter title"
                                    type="text"
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                    </Form.Row>
                    
                    </Modal.Body>
                    
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.AddNewGateway}>
                        Add New
                        </Button>
                        
                    </Modal.Footer>
                </Modal>


                </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ManageCommission);
